import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

// ─── Filtre déroulant générique (statut, agence, catégorie…) — style commun ───
export function FilterDropdown({ label, value, onChange, options, testid, defaultValue = "all" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  const active = value !== defaultValue;
  const current = options.find((o) => o.value === value);
  return (
    <div className="relative shrink-0" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className={`inline-flex items-center gap-1.5 h-10 px-3 rounded-xl border text-xs font-medium transition-colors ${
          active ? "border-violet-300 bg-violet-50 text-violet-700" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
        }`}
        data-testid={testid}
      >
        {active ? current?.label : label} <ChevronDown className={`h-3 w-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute left-0 top-11 z-40 w-52 max-h-72 overflow-y-auto bg-white border border-slate-200 rounded-xl shadow-xl p-1.5" data-testid={`${testid}-panel`}>
          {options.map((o) => (
            <button
              key={o.value}
              onClick={() => { onChange(o.value); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-2.5 py-2 text-xs rounded-lg text-left ${
                value === o.value ? "bg-violet-50 text-violet-700 font-semibold" : "text-slate-700 hover:bg-slate-50"
              }`}
              data-testid={`${testid}-opt-${o.value}`}
            >
              {o.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
